// src/components/First.js

import React, { useState, useEffect } from "react";
import "./First.css";

function First() {
  const [homeImages, setHomeImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // === DYNAMIC PADDING FOR HEADER ===
  useEffect(() => {
    const updatePadding = () => {
      const header = document.querySelector(".main-header");
      if (header) {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
      }
    };

    updatePadding(); // Initial
    window.addEventListener("resize", updatePadding);

    // Also update when mobile menu opens/closes (affects layout)
    const menuButton = document.querySelector(".menu-button");
    if (menuButton) {
      menuButton.addEventListener("click", updatePadding);
    }

    return () => {
      window.removeEventListener("resize", updatePadding);
      if (menuButton) menuButton.removeEventListener("click", updatePadding);
    };
  }, []);

  // Fetch home background images
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch("https://blog.dietchapter.hosting.acm.org/home-images");
        const data = await res.json();
        setHomeImages(data);
      } catch (err) {
        console.error("Error fetching home images:", err);
      }
    };
    fetchImages();
  }, []);

  // Auto rotate images
  useEffect(() => {
    if (homeImages.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % homeImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [homeImages]);

  const handleJoinNow = async () => {
    try {
      const res = await fetch("https://blog.dietchapter.hosting.acm.org/join-link");
      const data = await res.json();
      if (data?.link) window.open(data.link, "_blank");
      else alert("Join link not found.");
    } catch (err) {
      console.error("Error fetching join link:", err);
      alert("Unable to open the join link right now.");
    }
  };

  return (
    <section
      id="home"
      className="home-section"
      style={{
        backgroundImage:
          homeImages.length > 0
            ? `url(https://blog.dietchapter.hosting.acm.org/${homeImages[currentIndex].imagePath.replace(/\\/g, "/")})`
            : "linear-gradient(135deg, #0b132b, #1b2a49)",
      }}
    >
      <div className="home-overlay"></div>
      <div className="home-content">
        <h1>DADI INSTITUTE OF ENGINEERING AND TECHNOLOGY</h1>
        <h2>DIET ACM STUDENT CHAPTER</h2>
        <p>
          Fostering innovation, building community, and empowering the next
          generation of technology leaders
        </p>
        <div className="home-buttons">
          <button
            className="learn-more"
            onClick={() =>
              document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })
            }
          >
            Learn More
          </button>
          <button className="join-now" onClick={handleJoinNow}>
            Join Now
          </button>
        </div>
      </div>
    </section>
  );
}

export default First;